import { useState, useEffect, useContext, useRef } from "react";
import { DeviceContext } from "../context/DeviceContext";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Spinner from "react-bootstrap/Spinner";

const Scanner = () => {
	const rfidRef = useRef(null);
	const timeoutRef = useRef(null);
	const [deviceSession, setDeviceSession] = useContext(DeviceContext);
	const [time, setTime] = useState("");
	const [date, setDate] = useState("");
	const [rfidNo, setRfidNo] = useState("");
	const [group, setGroup] = useState("");
	const [user, setUser] = useState(null);
	const [loading, setLoading] = useState(false);
	const [open, setOpen] = useState(false);
	const [error, setError] = useState(null);

	const handleSubmit = async (e) => {
		e.preventDefault();

		if (timeoutRef.current) {
			clearTimeout(timeoutRef.current);
		}
		setError(null);
		setLoading(true);
		setOpen(true);

		const requestOptions = {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"X-Device-Token": deviceSession,
			},
			body: JSON.stringify({
				id_no: rfidNo,
				device: "Main Entrance",
			}),
		};

		try {
			const response = await fetch(
				`${process.env.REACT_APP_API_URI}/logs/`,
				requestOptions
			);
			const data = await response.json();

			if (!response.ok) {
				setError(data.msg);
			} else {
				setGroup(data.group);
				setUser(data.user);
			}
		} catch (err) {
			setError("An unexpected error occurred");
		} finally {
			timeoutRef.current = setTimeout(() => {
				setGroup("");
				setUser(null);
				setOpen(false);
			}, 4000);
		}
		setRfidNo("");
		setLoading(false);
	};

	useEffect(() => {
		let isCancelled = false;

		const sendHeartbeat = async () => {
			if (!deviceSession) return;

			const requestOptions = {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					"X-Device-Token": deviceSession,
				},
			};

			const response = await fetch(
				`${process.env.REACT_APP_API_URI}/devices/me`,
				requestOptions
			);

			if (!response.ok) {
				setDeviceSession(null);
			}

			if (!isCancelled) {
				setTimeout(sendHeartbeat, 30000);
			}
		};

		sendHeartbeat();

		return () => {
			isCancelled = true;
		};
	}, [deviceSession, setDeviceSession]);

	useEffect(() => {
		const updateClock = () => {
			const now = new Date();

			let hours = now.getHours();
			const minutes = now.getMinutes();
			const ampm = hours >= 12 ? "PM" : "AM";

			hours = hours % 12;
			hours = hours ? hours : 12;
			const formattedTime = `${String(hours).padStart(2, "0")}:${String(
				minutes
			).padStart(2, "0")} ${ampm}`;

			setTime(formattedTime);

			const formattedDate = now.toLocaleDateString("en-US", {
				year: "numeric",
				month: "long",
				day: "numeric",
			});

			setDate(formattedDate);
		};

		updateClock();
		const interval = setInterval(updateClock, 1000);

		return () => clearInterval(interval);
	}, []);

	return (
		<div
			className="full-page bg-white"
			onClick={() => rfidRef?.current?.focus()}
		>
			<Row className="gx-0">
				<Col className="col-8">
					<div
						className={`scanner-logo-container bg-white flex-row-right ${
							open ? "open" : "close"
						}`}
					>
						<img src="/scanner.png" alt="logo" className="scanner-logo" />
					</div>
					<div className="scanner-info flex-column">
						{loading ? (
							<Spinner className="page-loader-icon" />
						) : error ? (
							<span className="scanner-error text-danger">{error}</span>
						) : (
							<>
								<div
									className="scanner-photo rounded-8 bg-cover mb-30"
									style={{
										background: `url(${
											user?.photo ? user?.photo : "/default-user.png"
										})`,
									}}
								/>
								<span className="scanner-name">{user?.name}</span>
								{group === "Students" ? (
									<span className="scanner-details text-xl">{user?.level}</span>
								) : (
									<span className="scanner-details text-xl">
										{user?.department}
									</span>
								)}
							</>
						)}
					</div>
				</Col>
				<Col className="col-4">
					<div className="scanner-datetime flex-column">
						<span className="scanner-time text-white text-medium-inter">
							{time}
						</span>
						<span className="scanner-date text-white">{date}</span>
						<Form onSubmit={handleSubmit} className="scanner-form">
							<Form.Control
								ref={rfidRef}
								autoFocus
								value={rfidNo}
								onChange={(e) => setRfidNo(e.target.value)}
							/>
						</Form>
					</div>
				</Col>
			</Row>
		</div>
	);
};

export default Scanner;
